export const GET_VAT_SETTING_LIST = 'GET_VAT_SETTING_LIST';
export const GET_VAT_SETTING_LIST_SUCCESS = 'GET_VAT_SETTING_LIST_SUCCESS';
export const GET_VAT_SETTING_LIST_FAILED = 'GET_VAT_SETTING_LIST_FAILED';

export const CREATE_VAT_SETTING = 'CREATE_VAT_SETTING';
export const CREATE_VAT_SETTING_SUCCESS = 'CREATE_VAT_SETTING_SUCCESS';
export const CREATE_VAT_SETTING_FAILED = 'CREATE_VAT_SETTING_FAILED';

export const UPDATE_VAT_SETTING = 'UPDATE_VAT_SETTING';
export const UPDATE_VAT_SETTING_SUCCESS = 'UPDATE_VAT_SETTING_SUCCESS';
export const UPDATE_VAT_SETTING_FAILED = 'UPDATE_VAT_SETTING_FAILED';
